import { createElementBlock as l, openBlock as r, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return r(), l("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.057 3.179a1 1 0 0 1 1.277-.61C20.216 3.942 23 7.644 23 12c0 5.523-4.477 10-10 10S3 17.523 3 12c0-.752.083-1.486.242-2.192l-.838.369a1 1 0 0 1-.807-1.83l3.14-1.384a1 1 0 0 1 1.318.512l1.384 3.14a1 1 0 1 1-1.83.806l-.45-1.019a8 8 0 1 0 10.507-5.947 1 1 0 0 1-.609-1.276m-4.764 6.114a1 1 0 0 1 1.414 0L13 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L14.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L13 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L11.586 12l-1.293-1.293a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_reserve_cancel-DVPt-1UU.js.map
